import { reatomBoolean } from '@reatom/framework'

export const reatomAddWalletDrawerOpenedAtom = reatomBoolean(
  false,
  'reatomAddWalletDrawerOpenedAtom',
)
